import { LazyLoadImage } from 'react-lazy-load-image-component';
import styled from 'styled-components';

import GridContainer from '@r1-frontend/ui-react/components/layouts/gridContainer';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import DefaultPopup from '@r1-frontend/ui-react/components/popups/defaultPopup';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { TariffCardPlug } from '~/src/components/TariffCardPlug';

export const breakpoints = {
    desktop: '1599px',
    sDesktop: '1365px',
    tablet: '1122px',
    mobile: '768px',
    sMobile: '350px',
};

export const Wrapper = styled.div`
    display: block;
    overflow: hidden;
    width: 100%;
    padding: 0 90px;
    background: #fff;
    
    @media (max-width: ${breakpoints.tablet}) {
        padding: 0 0 0 16px;
    }
    
    @media (max-width: ${breakpoints.mobile}) {
        padding: 0;
    }
`;

export const Container = styled(GridContainer)`
    flex-direction: column;
    
    @media (max-width: 1599px) {
        width: 100%;
        max-width: 1360px;
        padding: 0;
    }

    @media (max-width: ${breakpoints.mobile}) {
        padding: 0 16px;
    }
`;

export const FormBlock = styled.div`
    width: 100%;
    
    @media (min-width: ${wideBreakpoints.mobile}) and (max-width: ${wideBreakpoints.laptop}) {
        padding-right: 16px;
    }
`;

export const Grid = styled.div`
    display: flex;
`;

export const STariffCardPlug = styled(TariffCardPlug)`
    margin-top: 24px;
`;

export const IncludesPopup = styled(DefaultPopup)`
    width: 600px;
    border-radius: ${BorderRadius.OuterBlockRadius};
    min-height: auto;
`;

export const ImageBlock = styled(LazyLoadImage)<{ src: string }>`
    width: 100%;
    background-size: cover;
    border-radius: ${BorderRadius.InnerBlockRadius};
`;

export const PopupInner = styled.div`
    padding: 32px;
    flex-direction: column;
`;

// @todo use @r1-frontend/ui-react/typography/heading
export const PopupTitle = styled.div`
    ${FONTS.H3}
    margin-bottom: 8px;
`;

// @todo use @r1-frontend/ui-react/typography/paragraph
export const PopupDescription = styled.div`
    ${FONTS.S}
    display: block;
    & ul li{
        background-image: url('/static/images/tariff-lines/list-style.png');
        background-repeat: no-repeat;
        padding-left: 45px;
        min-height: 40px;
        margin-bottom: 8px;
        line-height: 40px;
    }
    
    & ol {
        list-style: auto;
        padding-left: 20px;
    }
`;

export const PopupButtonBlock = styled.div`
    flex-direction: row;
    margin-top: 16px;
    & button:first-child{
        margin-right: 16px;
    }
    
    @media (max-width: ${breakpoints.mobile}) {
        & button{
            width: 100%;
        }
        & button:first-child{
            margin-right: 0;
            margin-bottom: 16px;
        }
    }
`;
